import { Button } from "../Button/Button";
import "./DeleteModal.scss";
import { ExclamationCircle } from "react-bootstrap-icons";
import Modal from 'react-bootstrap/Modal';

interface PropData {
  close: any;
  onDelete: any;
  message?: any;
  isShow: any
}

const DeleteModal = (props: PropData) => {
  const onCancel = () => {
    props.close();
  };

  return (
    <>
      {
        props.isShow &&
        <Modal show={props.isShow} onHide={onCancel}
          {...props}
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <div className="delete-modal mt-4">
            <form>
              <div className="form-style text-center">
                <div className="text-center mb-3">
                  <ExclamationCircle size={40} className="text-danger" />
                </div>
                <div className="text-dark">
                  {props.message
                    ? props.message
                    : "Are you sure, you want to delete this record ?"}{" "}
                </div>
                <div className="d-flex justify-content-center mt-4 mb-4">
                  <Button
                    size="large"
                    label="Yes"
                    b_type="SAVE"
                    onClick={() => props.onDelete()}
                  />
                  <span className="px-2"></span>
                  <Button
                    size="large"
                    label="No"
                    b_type="CANCEL"
                    onClick={() => onCancel()}
                  />
                </div>
              </div>
            </form>
          </div>
        </Modal>
      }
    </>
  );
};

export default DeleteModal;
